import { SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";

import styles from "./collections.module.css";
import { HeadingTitle, SwiperSlider } from "../shared/index";
import CollectionItem from "./CollectionItem/CollectionItem";

const Collections = ({ categories }) => {
  return (
    <section className={styles.collection__wrapper}>
      <HeadingTitle style={styles.heading} text="Shop by Category" />

      <SwiperSlider
        prevId="collectionPrevBtn"
        nextId="collectionNextBtn"
        wrapperClass={styles.collection__slider}
        prevBtnClass={`${styles.navButton} ${styles.prevButton}`}
        nextBtnClass={`${styles.navButton} ${styles.nextButton}`}
        slidesPerView={5}
        spaceBetween={16}
        breakpoints={{
          320: { slidesPerView: 1 },
          480: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 4 },
          1280: { slidesPerView: 5 },
        }}
      >
        {categories?.map((item) => (
          <SwiperSlide key={item.id}>
            <CollectionItem category={item} />
          </SwiperSlide>
        ))}
      </SwiperSlider>
    </section>
  );
};

export default Collections;